"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockChartData = exports.createMockChartBaseData = void 0;
const faker_1 = require("@faker-js/faker");
const mockMontlhyData = Array.from({ length: 12 }, () => faker_1.faker.datatype.number());
const mockQuarterlyData = Array.from({ length: 4 }, () => faker_1.faker.datatype.number());
const mockYearlyData = Array.from({ length: 6 }, () => faker_1.faker.datatype.number());
const createMockChartBaseData = (overwrites = {}) => (Object.assign({ data: [
        {
            mode: 'markers',
            type: 'bar',
            x: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ],
            y: mockMontlhyData,
            marker: { color: 'rgb(74, 102, 244)' },
            orientation: 'v',
        },
    ], layout: {}, config: { displayModeBar: false } }, overwrites));
exports.createMockChartBaseData = createMockChartBaseData;
const createMockChartData = (overwrites = {}) => (Object.assign({ title: faker_1.faker.lorem.words(), description: faker_1.faker.lorem.paragraph(), chartData: {
        monthly: [
            {
                mode: 'markers',
                type: 'bar',
                x: [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec',
                ],
                y: mockMontlhyData,
                marker: { color: 'rgb(74, 102, 244)' },
                orientation: 'v',
            },
        ],
        quarterly: [
            {
                mode: 'markers',
                type: 'bar',
                x: ['Q1', 'Q2', 'Q3', 'Q4'],
                y: mockQuarterlyData,
                marker: { color: 'rgb(74, 102, 244)' },
                orientation: 'v',
            },
        ],
        yearly: [
            {
                mode: 'markers',
                type: 'bar',
                x: ['2017', '2018', '2019', '2020', '2021', '2022'],
                y: mockYearlyData,
                marker: { color: 'rgb(74, 102, 244)' },
                orientation: 'v',
            },
        ],
    }, layout: {}, config: {
        displayModeBar: false,
    } }, overwrites));
exports.createMockChartData = createMockChartData;
//# sourceMappingURL=ChartData.factory.js.map